module.exports = __webpack_public_path__ + "img/CSAT_TH.b073224d.png";